import React,{useState} from 'react'
import '../App.css'

import WorkImages from './workImages'
import linkedinAutopilot from '../assets/images/linkedin-autopilot.png'

const container = {
  hidden: {  scale: 0,skewX:'10deg' },
  visible: {
    scale: 1,
    skewX:'0deg',
    transition: {
      delayChildren: 0.4,
      staggerChildren: 0.2
    }
  }
};

const item = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1
  }
};

const categories=["AI AUTOMATION","DATA PLATFORMS","B2B / SAAS","VOICE AI"]

// img, url and linkLabel are optional: a project without img shows a titled placeholder, without url it has no link
const work=[
  {
    id:6,
    name:"LinkedIn Autopilot",
    description:"Personal project: an AI content system that writes a LinkedIn post and image every day with Gemini, sends the draft to Telegram for approval, and publishes through the LinkedIn API only after a human tap. Six n8n workflows, PostgreSQL, Docker and a password-protected dashboard.",
    tags:["n8n","Gemini","PostgreSQL","Docker","Telegram Bot API","LinkedIn API"],
    category:"AI AUTOMATION",
    img:linkedinAutopilot,
    url:"https://drive.google.com/file/d/1S3t05WviOOMZhBFDvpTaumXo05JMG-FZ/view?usp=sharing",
    linkLabel:"View Case Study"
  },
  {
    id:1,
    name:"Transparent California",
    description:"Searchable public-pay and pension data platform handling millions of structured records, with data ingestion, bulk-upload validation and PostgreSQL search optimization.",
    tags:["PostgreSQL","Redis","AWS"],
    category:"DATA PLATFORMS",
    url:"https://transparentcalifornia.com"
  },
  {
    id:2,
    name:"Transparent Nevada",
    description:"Public-pay and pension search platform for Nevada, part of the same ecosystem as Transparent California along with its CRM systems, record-quality checks and migration workflows.",
    tags:["PostgreSQL","Data validation","AWS"],
    category:"DATA PLATFORMS",
    url:"https://transparentnevada.com"
  },
  {
    id:3,
    name:"Nevada Policy",
    description:"The Nevada Policy public website, which I contribute to as part of the same connected ecosystem of public data platforms and CRM systems.",
    tags:["Public website","CRM"],
    category:"DATA PLATFORMS",
    url:"https://nevadapolicy.org"
  },
  {
    id:4,
    name:"Noramark",
    description:"AI-powered U.S. industrial sourcing platform connecting buyers with verified domestic machine shops, spanning ERP, CRM, MRP, sourcing workflows and sales pipelines.",
    tags:["Full stack","ERP / CRM / MRP","API integrations"],
    category:"B2B / SAAS"
  },
  {
    id:5,
    name:"Voice AI Agents — NumbTec",
    description:"Voice agents built on Retell AI for 24/7 call handling, customer support, appointment setting and phone reception, connected to existing CRM systems.",
    tags:["Retell AI","Conversational AI","CRM integrations"],
    category:"VOICE AI"
  },
]

const OurWork=()=>{
  const [filter, setFilter] = useState({
    work
  });

  const filterProject=(e)=>{

    const newWork=work.filter((val,index)=>{
        return val.category===e.target.textContent
      })
      setFilter({work:newWork})
      // {...obj},[value]:name
  }

    return<>
        <section id='portfolio' className="text-gray-600 body-font">
  <div className="container md:w-[90%] w-[90%] px-5 lg:py-24 py-8 mx-auto">
    <div className="flex flex-col w-full mb-10">
      <h1 className="sm:text-5xl text-4xl font-medium title-font mb-4 text-gray-900">
        Latest Work
      </h1>
      <div className=" w-24 sm:h-1 md:h-2  my-2 rounded-full sm:mt-0 inline-flex bg-gradient-to-r from-yellow-300 to-yellow-400 text-white relative z-10 title-font font-medium text-sm ">
      </div>
      <p className="lg:w-2/3 leading-relaxed text-base">Client products I have worked on as Team Lead and Senior Software Engineer.</p>
    </div>
    <div className='container px-5 mx-auto flex flex-wrap justify-center gap-4'>
        <button onClick={()=>{setFilter({work})}} className="shadow-lg inline-flex text-gray-700 bg-gradient-to-l to-[yellow] from-yellow-300 border-0 py-2 px-6 focus:outline-none hover:bg-yellow-300 rounded text-lg">All Projects</button>
        {categories.map((category)=>(
        <button onClick={filterProject} key={category} className="shadow-lg inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">{category}</button>
        ))}
    </div>

    <WorkImages filter={filter} container={container} item={item} />

  </div>
</section>

    </>
}


export default OurWork;
